export const clamp = (n: number, { min, max }: { min: number; max: number }) =>
  isNaN(n) ? NaN : Math.min(Math.max(n, min), max);

export const metresToFeet = (n: number) => n * 3.28084;
export const feetToMetres = (n: number) => n / 3.28084;
export const feetToMiles = (n: number) => n / 5280;
export const noConversion = (n: number) => n;
